export default "__VITE_ASSET__B$27kb4Y__"